const store = createPinia()
import piniaPersist from 'pinia-plugin-persistedstate';
store.use(piniaPersist);

export default store